export const VEHICLE_TYPES = [
  "FIORINO",
  "3/4",
  "TOCO",
  "VUC",
  "TRUCK",
  "BI-TRUCK",
  "BI-TREM",
  "CARRETA S",
  "CARRETA LS",
  "RODOTREM",
  "VANDERLEIA",
];

export const BODY_TYPES = [
  "BAÚ",
  "BAÚ FRIGORIFICO",
  "BAÚ REFRIGERADO",
  "SIDER",
  "CAÇAMBA",
  "GRADE BAIXA",
  "GRANELEIRO",
  "PLATAFORMA",
  "PRANCHA",
  "APENAS CAVALO",
  "BUG PORTA CONTAINER",
  "CAVAQUEIRA",
  "CEGONHEIRO",
  "GAIOLA",
  "HOPPER",
  "MUNCK",
  "SILLO",
  "TANQUE",
];

export const EMPTY_FILTERS = {
  number: "",
  origin: "",
  destination: "",
  vehicleType: "",
  bodyType: "",
  collectionDate: "",
  onlyMyShippers: true,
  contractingType: "ALL",
  sort: "collectionAsc",
};

export function formatCurrency(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatFreightValueDisplay(value, pricingType) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";

  if (String(pricingType || "").trim().toLowerCase() === "ton") {
    return `${num.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} / Ton`;
  }

  return formatCurrency(num);
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  if (dateStr.includes("/")) return dateStr;
  const [year, month, day] = String(dateStr).split("-");
  if (!year || !month || !day) return dateStr;
  return `${day}/${month}/${year}`;
}
